import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import NavBarOne from "../../../components/navbar/navbarOne";
import styles from "./header.module.scss";
const Header = ({ onSearchFocus, }) => {
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: styles.wrapper }, { children: _jsx(NavBarOne, { onSearchFocus: onSearchFocus }) })) }));
};
export default Header;
